<template>
    <aside class="sidebar d-flex flex-column min-vh-100" id="sidebar">
        <div class="sidebar-header d-flex flex-row align-items-center">
            <img src="@/assets/images/OgunLogo.svg" alt="Logo">
            <div>
                <h2 class="mb-0 text-nowrap t-main">O.G.P.A.B.S.</h2>
                <!-- <h5 class="t-sub mb-0">Planning & Budgeting System</h5> -->
                <h5 class="t-sub mb-0">{{ environmentName }}</h5>
            </div>
        </div>
        <nav class="sidebar-nav" :key="menuVersion">
            <!-- Dashboard -->
            <div class="outer-link">
                <router-link :to="{ name: 'Dashboard' }"
                    class="d-flex align-items-center text-secondary text-decoration-none"
                    :class="{ active: $route.name === 'Dashboard' }">
                    <span class="material-symbols-outlined me-3">home</span>
                    <p class="mb-0 w-100">Dashboard</p>
                </router-link>
            </div>

            <!-- Executive Dashboard -->
            <div class="outer-link" v-if="hasAccess(['']) && hasBizClientAccess([1001])">
                <router-link :to="{ name: 'ExecutiveDashboard' }"
                    class="d-flex align-items-center text-secondary text-decoration-none"
                    :class="{ active: $route.name === 'ExecutiveDashboard' }">
                    <span class="material-symbols-outlined me-3">analytics</span>
                    <p class="mb-0 w-100">Executive Dashboard</p>
                </router-link>
            </div>

            <!-- Memos -->
            <div class="outer-link"
                v-if="hasAccess(['registryOfficer', 'qssu', '', 'groupHead', 'groupMember', 'dirOfBudget', 'perSec', 'commOfBAndP']) && hasBizClientAccess([1000])">
                <router-link :to="{}"
                    class="dropdown-toggle d-flex align-items-center text-secondary text-decoration-none"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['CreateMemo', 'ViewMemos', 'ViewAdminMemos'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">description</span>
                    <p class="mb-0 w-100">Memos</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess(['registryOfficer', 'qssu', ''])">
                        <router-link :to="{ name: 'CreateMemo' }" class="dropdown-item">Create Memo</router-link>
                    </li>
                    <li><router-link :to="{ name: 'ViewMemos' }" class="dropdown-item">View Memos</router-link></li>
                    <li v-if="hasAccess([''])"><router-link :to="{ name: 'ViewAdminMemos' }" class="dropdown-item">View
                            Memos (Admin)</router-link></li>
                </ul>
            </div>

            <!-- Appraisals -->
            <div class="outer-link"
                v-if="hasAccess(['registryOfficer', 'qssu', '', 'groupHead', 'groupMember', 'dirOfBudget', 'perSec', 'commOfBAndP']) && hasBizClientAccess([1000])">
                <router-link :to="{}"
                    class="dropdown-toggle d-flex align-items-center text-secondary text-decoration-none"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['ViewAppraisals', 'ViewManualAppraisals', 'ImportManualAppraisals', 'CreateSpecialApproval', 'ViewSpecialApprovals', 'UpdateSpecialApproval', 'ViewSpecialApprovalTypes', 'ViewSpecialApprovalType', 'CreateSpecialApprovalType'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">rate_review</span>
                    <p class="mb-0 w-100">Appraisals</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li><router-link :to="{ name: 'ViewAppraisals' }" class="dropdown-item">View
                            Appraisals</router-link></li>
                    <li><router-link :to="{ name: 'ViewManualAppraisals' }" class="dropdown-item">View Manual
                            Appraisals</router-link></li>
                    <li v-if="hasAccess(['registryOfficer', '', 'qssu', 'groupHead', 'groupMember'])">
                        <router-link :to="{ name: 'ImportManualAppraisals' }" class="dropdown-item">Import Manual
                            Appraisal</router-link>
                    </li>
                    <li><router-link :to="{ name: 'ViewSpecialApprovals' }" class="dropdown-item">View Special
                            Approvals</router-link></li>
                    <li v-if="hasAccess(['groupHead', 'groupMember'])"><router-link
                            :to="{ name: 'CreateSpecialApproval' }" class="dropdown-item">Create Special
                            Approval</router-link></li>
                    <li><router-link :to="{ name: 'ViewSpecialApprovalTypes' }" class="dropdown-item">View Special
                            Approval Types</router-link></li>
                    <li v-if="hasAccess(['groupHead', 'groupMember'])"><router-link
                            :to="{ name: 'CreateSpecialApprovalType' }" class="dropdown-item">Create Special Approval
                            Type</router-link></li>
                </ul>
            </div>

            <!-- Warrants -->
            <div class="outer-link"
                v-if="hasAccess(['', 'qssu', 'groupHead', 'groupMember']) && hasBizClientAccess([1000, 1001])">
                <router-link :to="{}"
                    class="dropdown-toggle d-flex align-items-center text-secondary text-decoration-none"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['ViewWarrants', 'ViewWarrant', 'ViewVoidedWarrants'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">article</span>
                    <p class="mb-0 w-100">Warrants</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess(['groupHead', 'groupMember', ''])">
                        <router-link :to="{ name: 'ViewWarrants' }" class="dropdown-item">Active Warrants</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'ViewVoidedWarrants' }" class="dropdown-item">Voided
                            Warrants</router-link>
                    </li>
                </ul>
            </div>

            <!-- Unlinked PVs -->
            <div class="outer-link" v-if="hasAccess(['', 'registryOfficer', 'qssu']) && hasBizClientAccess([1000])">
                <router-link :to="{ name: 'ViewUnlinkedPaymentVouchers' }" href="#"
                    class="d-flex align-items-center text-secondary text-decoration-none">
                    <span class="material-symbols-outlined me-3">receipt_long</span>
                    <p class="mb-0 w-100">Unlinked PVs</p>
                </router-link>
            </div>

            <!-- Budget Management -->
            <div class="outer-link" v-if="hasAccess(['qssu', 'perSec', 'commOfBAndP', '']) && hasBizClientAccess([1000])">
                <router-link :to="{}"
                    class="dropdown-toggle d-flex align-items-center text-secondary text-decoration-none"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['EditBudget', 'UploadBudget', 'CreateEconomicLineItem', 'SearchLineItem', 'ViewLineItem', 'ViewBudgets', 'BudgetPerformanceDashboard'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">account_balance_wallet</span>
                    <p class="mb-0 w-100">Budget Management</p>
                </router-link>

                <ul v-if="hasAccess(['qssu', 'perSec', 'commOfBAndP', ''])" class="submenu submenu dropdown-menu no-animation"
                    aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess(['qssu', ''])">
                        <router-link :to="{ name: 'UploadBudget' }" class="dropdown-item">Upload Budget</router-link>
                    </li>
                    <li v-if="hasAccess(['qssu', ''])">
                        <router-link :to="{ name: 'EditBudget' }" class="dropdown-item">Edit Budget</router-link>
                    </li>
                    <li v-if="hasAccess(['qssu', 'perSec', 'commOfBAndP', ''])">
                        <router-link :to="{ name: 'ViewBudgets' }" class="dropdown-item">View Budgets</router-link>
                    </li>
                    <li v-if="hasAccess(['qssu', ''])">
                        <router-link :to="{ name: 'CreateEconomicLineItem' }" class="dropdown-item">Create Economic Line
                            Item</router-link>
                    </li>
                    <li v-if="hasAccess(['perSec', 'commOfBAndP', ''])">
                        <router-link :to="{ name: 'BudgetPerformanceDashboard' }" class="dropdown-item">Budget
                            Performance</router-link>
                    </li>
                </ul>
            </div>

            <!-- Control Entities -->
            <div class="outer-link" v-if="hasBizClientAccess([1000, 1001])">
                <router-link :to="{}"
                    class="d-flex align-items-center text-secondary text-decoration-none dropdown-toggle"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['ViewMdas', 'CreateMda', 'ViewUsers', 'CreateUser', 'ViewRoles', 'CreateRole', 'ViewSectors', 'CreateSector', 'ViewSubSectors', 'CreateSubSector', 'ViewApprovalAuthorities', 'CreateApprovalAuthority', 'EditApprovalAuthority', 'ViewOccupiers', 'CreateOccupier'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">tune</span>
                    <p class="mb-0 w-100">Control Entities</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <!-- MDA Functions -->
                    <li>
                        <a href="#" class="dropdown-item group-toggle" @click.stop.prevent="toggleEntityGroup('mda')">
                            <span class="w-100">MDA Functions</span>
                            <span class="material-symbols-outlined">{{ openEntityGroup === 'mda' ? 'expand_less' : 'expand_more' }}</span>
                        </a>
                        <ul v-show="openEntityGroup === 'mda'" class="list-unstyled nested-menu">
                            <li><router-link :to="{ name: 'ViewMdas' }" class="dropdown-item">View Mdas</router-link></li>
                            <li v-if="hasAccess(['', 'qssu']) && hasBizClientAccess([1000])">
                                <router-link :to="{ name: 'CreateMda' }" class="dropdown-item">Create Mda</router-link>
                            </li>
                        </ul>
                    </li>

                    <!-- User Functions -->
                    <li v-if="hasAccess(['', 'qssu'])">
                        <a href="#" class="dropdown-item group-toggle" @click.stop.prevent="toggleEntityGroup('users')">
                            <span class="w-100">User Functions</span>
                            <span class="material-symbols-outlined">{{ openEntityGroup === 'users' ? 'expand_less' : 'expand_more' }}</span>
                        </a>
                        <ul v-show="openEntityGroup === 'users'" class="list-unstyled nested-menu">
                            <li v-if="hasAccess(['qssu', ''])">
                                <router-link :to="{ name: 'ViewUsers' }" class="dropdown-item">View Users</router-link>
                            </li>
                            <li v-if="hasAccess(['', 'qssu'])">
                                <router-link :to="{ name: 'CreateUser' }" class="dropdown-item">Create New User</router-link>
                            </li>
                        </ul>
                    </li>

                    <!-- Roles -->
                    <li v-if="hasAccess(['', 'qssu'])">
                        <a href="#" class="dropdown-item group-toggle" @click.stop.prevent="toggleEntityGroup('roles')">
                            <span class="w-100">Roles</span>
                            <span class="material-symbols-outlined">{{ openEntityGroup === 'roles' ? 'expand_less' : 'expand_more' }}</span>
                        </a>
                        <ul v-show="openEntityGroup === 'roles'" class="list-unstyled nested-menu">
                            <li v-if="hasAccess(['qssu', ''])">
                                <router-link :to="{ name: 'ViewRoles' }" class="dropdown-item">View Roles</router-link>
                            </li>
                            <li v-if="hasAccess([''])">
                                <router-link :to="{ name: 'CreateRole' }" class="dropdown-item">Create Role</router-link>
                            </li>
                        </ul>
                    </li>

                    <!-- Sectors -->
                    <li>
                        <a href="#" class="dropdown-item group-toggle" @click.stop.prevent="toggleEntityGroup('sectors')">
                            <span class="w-100">Sectors</span>
                            <span class="material-symbols-outlined">{{ openEntityGroup === 'sectors' ? 'expand_less' : 'expand_more' }}</span>
                        </a>
                        <ul v-show="openEntityGroup === 'sectors'" class="list-unstyled nested-menu">
                            <li><router-link :to="{ name: 'ViewSectors' }" class="dropdown-item">View Sectors</router-link></li>
                            <li v-if="hasAccess(['', 'qssu']) && hasBizClientAccess([1000])">
                                <router-link :to="{ name: 'CreateSector' }" class="dropdown-item">Create Sector</router-link>
                            </li>
                            <li><router-link :to="{ name: 'ViewSubSectors' }" class="dropdown-item">View
                                    Sub-sectors</router-link></li>
                            <li v-if="hasAccess(['', 'qssu']) && hasBizClientAccess([1000])">
                                <router-link :to="{ name: 'CreateSubSector' }" class="dropdown-item">Create Sub
                                    Sector</router-link>
                            </li>
                        </ul>
                    </li>

                    <!-- Approval Authorities -->
                    <li>
                        <a href="#" class="dropdown-item group-toggle" @click.stop.prevent="toggleEntityGroup('authorities')">
                            <span class="w-100">Approval Authorities</span>
                            <span class="material-symbols-outlined">{{ openEntityGroup === 'authorities' ? 'expand_less' : 'expand_more' }}</span>
                        </a>
                        <ul v-show="openEntityGroup === 'authorities'" class="list-unstyled nested-menu">
                            <li v-if="hasAccess(['qssu', ''])">
                                <router-link :to="{ name: 'ViewApprovalAuthorities' }" class="dropdown-item">View Approval
                                    Authorities</router-link>
                            </li>
                            <li v-if="hasAccess(['', 'qssu']) && hasBizClientAccess([1000])">
                                <router-link :to="{ name: 'CreateApprovalAuthority' }" class="dropdown-item">Create Approval
                                    Authority</router-link>
                            </li>
                            <li><router-link :to="{ name: 'ViewOccupiers' }" class="dropdown-item">View Occupiers</router-link>
                            </li>
                            <li v-if="hasAccess(['', 'qssu']) && hasBizClientAccess([1000])">
                                <router-link :to="{ name: 'CreateOccupier' }" class="dropdown-item">Create
                                    Occupier</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <!-- Delegation -->
            <div class="outer-link" v-if="hasAccess(['perSec', 'commOfBAndP', '']) && hasBizClientAccess([1000])">
                <router-link :to="{}"
                    class="d-flex align-items-center text-secondary text-decoration-none dropdown-toggle"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['CreateDelegation', 'ViewDelegation', 'ViewDelegationLog'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">swap_horiz</span>
                    <p class="mb-0 w-100">Delegation</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess(['perSec', 'commOfBAndP', ''])">
                        <router-link :to="{ name: 'CreateDelegation' }" class="dropdown-item">Delegate</router-link>
                    </li>
                    <li v-if="hasAccess(['perSec', 'commOfBAndP', ''])">
                        <router-link :to="{ name: 'ViewDelegation' }" class="dropdown-item">Revoke</router-link>
                    </li>
                    <!-- <li v-if="hasAccess(['perSec','commOfBAndP',''])">
                        <router-link :to="{ name: 'ViewDelegationLog' }" class="dropdown-item">View Delegation Log</router-link>
                    </li> -->
                </ul>
            </div>

            <!-- Reports -->
            <div class="outer-link" v-if="hasBizClientAccess([1000, 1001])">
                <router-link :to="{}"
                    class="d-flex align-items-center text-secondary text-decoration-none dropdown-toggle"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['ViewDailySummary', 'ViewFileRegister'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">summarize</span>
                    <p class="mb-0 w-100">Reports</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li><router-link :to="{ name: 'ViewDailySummary' }" class="dropdown-item">View Daily
                            Summaries</router-link></li>
                    <li><router-link :to="{ name: 'ViewFileRegister' }" class="dropdown-item">View File
                            Register</router-link></li>
                </ul>
            </div>

            <!-- Banks -->
            <div class="outer-link" v-if="hasAccess(['']) && hasBizClientAccess([1001])">
                <router-link :to="{}"
                    class="dropdown-toggle d-flex align-items-center text-secondary text-decoration-none"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['CreateBank', 'ViewBanks', 'ViewBank', 'EditBank'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">account_balance</span>
                    <p class="mb-0 w-100">Banks</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li>
                        <router-link :to="{ name: 'CreateBank' }" class="dropdown-item">Create Bank</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'ViewBanks' }" class="dropdown-item">View Banks</router-link>
                    </li>
                </ul>
            </div>

            <!-- Cashbook -->
            <div class="outer-link" v-if="hasAccess(['groupHead', '']) && hasBizClientAccess([1001])">
                <router-link :to="{ name: 'CashBook' }" href="#"
                    class="d-flex align-items-center text-secondary text-decoration-none">
                    <span class="material-symbols-outlined me-3">checkbook</span>
                    <p class="mb-0 w-100">Cashbook</p>
                </router-link>
            </div>

            <!-- Consultants -->
            <div class="outer-link" v-if="hasAccess(['', 'qssu']) && hasBizClientAccess([1001])">
                <router-link :to="{}"
                    class="d-flex align-items-center text-secondary text-decoration-none dropdown-toggle"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['RegisterConsultant', 'ViewConsultants'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">article_person</span>
                    <p class="mb-0 w-100">Consultants</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess(['', 'qssu'])">
                        <router-link :to="{ name: 'RegisterConsultant' }" class="dropdown-item">Create New
                            Consultant</router-link>
                    </li>
                    <li v-if="hasAccess(['', 'qssu'])">
                        <router-link :to="{ name: 'ViewConsultants' }" class="dropdown-item">View
                            Consultants</router-link>
                    </li>
                </ul>
            </div>

            <!-- Deductions -->
            <div class="outer-link" v-if="hasAccess(['']) && hasBizClientAccess([1001])">
                <router-link :to="{}"
                    class="d-flex align-items-center text-secondary text-decoration-none dropdown-toggle"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['CreateDelegation', 'ViewDelegation', 'ViewDelegationLog'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">indeterminate_check_box</span>
                    <p class="mb-0 w-100">Deductions</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess([''])">
                        <router-link :to="{ name: 'CreateDeduction' }" class="dropdown-item">Create
                            Deduction</router-link>
                    </li>
                    <li v-if="hasAccess(['perSec', 'commOfBAndP', ''])">
                        <router-link :to="{ name: 'ViewDeductions' }" class="dropdown-item">View
                            Deductions</router-link>
                    </li>
                </ul>
            </div>

            <!-- Payments -->
            <div class="outer-link" v-if="hasAccess(['', 'pvInitiator']) && hasBizClientAccess([1001])">
                <router-link :to="{}"
                    class="d-flex align-items-center text-secondary text-decoration-none dropdown-toggle"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['ViewPaymentVouchers', 'ViewUnlinkedPaymentVouchers'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">receipt_long</span>
                    <p class="mb-0 w-100">Payments</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess(['', 'pvInitiator']) && hasBizClientAccess([1001])">
                        <router-link :to="{ name: 'ViewPaymentVouchers' }" class="dropdown-item">View Payment
                            Vouchers</router-link>
                    </li>
                    <li v-if="hasAccess(['', 'registryOfficer', 'qssu', 'pvInitiator'])">
                        <router-link :to="{ name: 'ViewUnlinkedPaymentVouchers' }" class="dropdown-item">View PVs
                            Without Warrant</router-link>
                    </li>
                </ul>
            </div>

            <!-- PV Memo -->
            <div class="outer-link" v-if="hasBizClientAccess([1001])">
                <router-link :to="{}"
                    class="dropdown-toggle d-flex align-items-center text-secondary text-decoration-none"
                    id="userFunctionsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                    :class="{ active: ['CreatePVMemo', 'ViewPVMemos'].includes($route.name) }">
                    <span class="material-symbols-outlined me-2">add_notes</span>
                    <p class="mb-0 w-100">PV Memo</p>
                </router-link>

                <ul class="submenu dropdown-menu no-animation" aria-labelledby="userFunctionsDropdown">
                    <li v-if="hasAccess(['', 'initiator'])">
                        <router-link :to="{ name: 'CreatePVMemo' }" class="dropdown-item">Create PV Memo</router-link>
                    </li>
                    <li v-if="hasAccess(['', 'initiator'])">
                        <router-link :to="{ name: 'ViewPVMemos' }" class="dropdown-item">View PV Memos</router-link>
                    </li>
                </ul>
            </div>

            <!-- Help -->
            <div class="outer-link">
                <router-link :to="{}" href="#" class="d-flex align-items-center text-secondary text-decoration-none">
                    <span class="material-symbols-outlined me-3">contact_support</span>
                    <p class="mb-0 w-100">Help</p>
                </router-link>
            </div>
        </nav>

        <!-- <div class="logout-button">
            <a href="#" @click.prevent="logout" class="logout d-flex align-items-center text-decoration-none">
                <span class="material-symbols-outlined me-2">logout</span>
                <p class="mb-0">Logout</p>
            </a>
        </div> -->

    </aside>
</template>

<script>
import { computed, watch, ref } from 'vue'
import Cookies from 'js-cookie'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

export default {
    setup() {
        const router = useRouter()
        const userStore = useUserStore()
        // const userRole = userStore.profile?.role || {};

        // check if current user has permission
        // const allRoles = [
        //     'qssu',
        //     'dirOfBudget',
        //     'perSec',
        //     'commOfBAndP',
        //     'registryOfficer',
        //     'groupHead'
        // ];

        // const hasAccess = (required) => {
        //     const profileRoles = userStore.profile?.role || {}; // object of roles

        //     // Helper to check if user has a role
        //     const userHasRole = (role) => !!profileRoles[role];

        //     if (!required || required.length === 0) return true; // no restriction

        //     // If array contains empty string
        //     if (required.includes('')) {
        //         const otherRoles = required.filter(role => role !== '');

        //         // Explicitly listed roles are allowed
        //         if (otherRoles.some(role => userHasRole(role))) return true;

        //         // Free users (roles not in allRoles) get full access
        //         const isFreeUser = Object.keys(profileRoles).every(r => !allRoles.includes(r) || profileRoles[r] === false);
        //         if (isFreeUser) return true;

        //         // Predefined roles not explicitly listed are denied
        //         return false;
        //     }

        //     // Normal role check
        //     return required.some(role => userHasRole(role));
        // }

        const allRoles = [
            'qssu',
            'dirOfBudget',
            'perSec',
            'commOfBAndP',
            'registryOfficer',
            'groupHead',
            'groupMember',
            'initiator'
        ]

        // reactive computed wrapper around the store role object
        const profileRoles = computed(() => userStore.profile?.role || {})

        // reactive computed wrapper around bizClientId
        const bizClientId = computed(() => userStore.bizClientId || 1000)

        const ENV_MAP = {
            1000: "Budget",
            1001: "Payment"
        }

        const environmentName = computed(() => ENV_MAP[bizClientId.value] || "Unknown")

        // force re-render of the menu when roles change
        const menuVersion = ref(0)

        // which Control Entities group is expanded (one at a time)
        const openEntityGroup = ref(null)

        const toggleEntityGroup = (group) => {
            openEntityGroup.value = openEntityGroup.value === group ? null : group
        }

        // Check if user has business client access
        const hasBizClientAccess = (requiredBizClients) => {
            if (!requiredBizClients || requiredBizClients.length === 0) return true
            return requiredBizClients.includes(bizClientId.value)

        }

        watch(
            profileRoles,
            (newRoles, oldRoles) => {
                if (!oldRoles) {
                    // console.log('Initial roles set:', newRoles)
                    return
                }
                if (JSON.stringify(newRoles) !== JSON.stringify(oldRoles)) {
                    menuVersion.value++
                    // console.log('Roles changed:', { oldRoles, newRoles })
                }
            },
            { deep: true, immediate: true }
        )

        // hasAccess now reads profileRoles.value (reactive)
        const hasAccess = (required) => {
            const profile = profileRoles.value

            const userHasRole = (role) => !!profile[role]

            if (!required || required.length === 0) return true

            if (required.includes('')) {
                const otherRoles = required.filter(role => role !== '')

                if (otherRoles.some(role => userHasRole(role))) return true

                // detect "free" user (no flagged roles)
                const isFreeUser = Object.keys(profile).every(r => !allRoles.includes(r) || profile[r] === false)
                if (isFreeUser) return true

                return false
            }

            return required.some(role => userHasRole(role))
        }

        const logout = () => {
            Cookies.remove('auth_token')
            router.push({ name: 'Login' })
        }

        return {
            // user_id: userStore.profile.id,
            hasAccess,
            hasBizClientAccess,
            logout,
            menuVersion,
            environmentName,
            openEntityGroup,
            toggleEntityGroup
        }
    }
}
</script>

<style scoped>
.logout-button {
    /* position: absolute; */
    /* bottom: 20px; */
    left: 0;
    right: 0;
    text-align: center;
}

.group-toggle {
    font-weight: 600;
}

.group-toggle .material-symbols-outlined {
    font-size: 20px;
}

.nested-menu {
    margin-left: 12px;
    border-left: 2px solid var(--sidebar-active-bg);
}
</style>
